import React, { useEffect, useState } from 'react'
import Navbar from './navbar'
import './style.css';
import UseFetch from '../hooks/useFetch';
import UseSend from '../hooks/useSend';
import UseGet from '../hooks/useGet';

function Home() {
  const [index,setIndex] = useState(0)
  const {getData,data} = UseFetch()
  const {sendData,result,error} = UseSend()
  const {GetScore,score} = UseGet()
  useEffect(()=>{
    getData()
  },[getData])
  if (!data || data.length === 0) {
    return null; // or return a loading indicator or handle the case appropriately
  }
  // console.log(data)
  const question = data[index] ? data[index].text :'';
  const questionId = data[index] ? data[index].id :'';
  const answers = data[index] ? data[index].answers :'';
  // console.log(question)


  const sendAnswerHandler =(answer,questionId) =>{
    // console.log(questionId)
    const token =  localStorage.getItem('token');

    if(token ==null){
      alert('You need to sign in first')
      return
    }
    sendData(questionId,answer,token)
    GetScore(token);
    setIndex((prevIndex)=> prevIndex + 1)

  }
  // console.log(score)
  return (
    <>
     <Navbar score={score} />
     <div style={{display:'flex',justifyContent:'center'}}>
      {result ? <p className={result.message == 'your answer was correct' ? 'success' :'alert'}>{result.message}</p> :''}
     </div>

     <div style={{height:400,display:'flex',justifyContent:'center',alignItems:'center'}}>
        <div style={{backgroundColor:'#1e81b0',height:290,width:'50%',borderRadius:10,display:'flex',flexDirection:'column',alignItems:'center'}}>
       <h4 style={{color:'white'}}>{question}</h4>
       <div style={{display:'flex',flexDirection:'row'}}>
        {answers.map((item,index)=>(
          <div className='question' key={index} onClick={sendAnswerHandler.bind(this,item,questionId)}>
          <p>{item}</p>  
          </div>
        ))}
      

       </div>

      </div>
     </div>
    
    </>
  )
}

export default Home
